export default "__VITE_ASSET__CLAte011__"